import n from 'vscode/external/rollup-plugin-styles/dist/runtime/inject-css.js';

var css = ".quick-input-list .quick-input-list-entry.has-actions:hover .quick-input-list-entry-action-bar .action-label.dirty-anything:before{content:var(--vscode-icon-x-content);font-family:var(--vscode-icon-x-font-family)}";
n(css,{});

export { css, css as default };
